/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react'
import Button from '@components/common/Button/Button.component'
import './KeypadStyle.css'

type KeyPadData = {
  main: string
  sub: string
}

export const NUMPAD_DATA: KeyPadData[][] = [
  [
    { main: '1', sub: ' ' },
    { main: '2', sub: 'ABC' },
    { main: '3', sub: 'DEF' },
  ],
  [
    { main: '4', sub: 'GHI' },
    { main: '5', sub: 'JKL' },
    { main: '6', sub: 'MNO' },
  ],
  [
    { main: '7', sub: 'PQRS' },
    { main: '8', sub: 'TUV' },
    { main: '9', sub: 'WXYZ' },
  ],
  [
    { main: '*', sub: ' ' },
    { main: '0', sub: '+' },
    { main: '#', sub: ' ' },
  ],
]

type KeypadProps = {
  onClick: (key: string) => void
  disabled?: boolean
}

const Keypad = ({ onClick, disabled }: KeypadProps): React.ReactElement => {
  return (
    <div className="keypad-component">
      {NUMPAD_DATA.map((row, index) => {
        return (
          <div key={index} className={`kc-row kc-row-${index}`}>
            {row.map((data, rowIndex) => {
              return (
                <Button
                  key={`${index}-${rowIndex}`}
                  className="numpad-button"
                  onClick={() => onClick(data.main)}
                  disabled={disabled}
                >
                  <div className="keypad-number">{data.main}</div>
                  <div className="keypad-small-text">{data.sub}</div>
                </Button>
              )
            })}
          </div>
        )
      })}
    </div>
  )
}

export default Keypad
